<template>
  <button
    @click="showNotepad"
    title="Take notes"
    v-tippy><font-awesome-icon :icon="faPenAlt" /></button>
</template>

<script>
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  import { faPenAlt } from '@fortawesome/pro-light-svg-icons/faPenAlt'
  import { createNamespacedHelpers } from 'vuex'

  const { mapActions } = createNamespacedHelpers('conference')

  export default {
    components: {
      FontAwesomeIcon
    },
    data () {
      return {
        faPenAlt
      }
    },
    methods: mapActions([
      'showNotepad'
    ])
  }
</script>




// WEBPACK FOOTER //
// notepad-button.vue?c0f698aa